// store/slices/uiSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { readXrayPanelInitial } from '../middleware/xrayPanelStorage'

type ActiveSidePanel = 'main' | 'ai' | 'chat' | 'phone'

interface UIState {
  activeSidePanel: ActiveSidePanel
  isSidePanelOpen: boolean
  showCallerDetails: boolean
  isHIPAAView: boolean
  isXrayPanelOpen: boolean
  // Bumped to explicitly re-open the tray-owned select-patient modal after dismissal
  patientSelectionRequestId: number
}

const initialState: UIState = {
  activeSidePanel: 'main',
  isSidePanelOpen: false,
  showCallerDetails: false,
  isHIPAAView: false,
  isXrayPanelOpen: readXrayPanelInitial(),
  patientSelectionRequestId: 0,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidePanel(state, action: PayloadAction<boolean | undefined>) {
      state.isSidePanelOpen =
        action.payload !== undefined ? action.payload : !state.isSidePanelOpen
    },
    openSidePanel(state) {
      state.isSidePanelOpen = true
    },
    closeSidePanel(state) {
      state.isSidePanelOpen = false
    },
    setActiveSidePanel(state, action: PayloadAction<ActiveSidePanel>) {
      state.activeSidePanel = action.payload
      state.isSidePanelOpen = true
    },
    setShowCallerDetails(state, action: PayloadAction<boolean>) {
      state.showCallerDetails = action.payload
    },
    setHIPAAView(state, action: PayloadAction<boolean>) {
      state.isHIPAAView = action.payload
    },
    toggleHIPAAView(state) {
      state.isHIPAAView = !state.isHIPAAView
    },
    setXrayPanelOpen(state, action: PayloadAction<boolean>) {
      state.isXrayPanelOpen = action.payload
    },
    toggleXrayPanel(state) {
      state.isXrayPanelOpen = !state.isXrayPanelOpen
    },
    requestPatientSelection(state) {
      state.patientSelectionRequestId += 1
    },
  },
})

export const {
  toggleSidePanel,
  openSidePanel,
  closeSidePanel,
  setActiveSidePanel,
  setShowCallerDetails,
  setHIPAAView,
  toggleHIPAAView,
  setXrayPanelOpen,
  toggleXrayPanel,
  requestPatientSelection,
} = uiSlice.actions
export default uiSlice.reducer
